import {
    Component,
    ElementRef,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs-compat/Observable';
import { filter } from 'rxjs/operators';
import { Permission } from 'src/app/library/config/auth/permissions/permission';
import { EnvironmentService } from 'src/app/library/services/core/environment.service';
import { NavigationService } from 'src/app/library/services/general/navigation.service';
import { SideNavService } from 'src/app/library/services/side-nav/side-nav.service';
import { NotificationService } from 'src/app/modules/notifications/services/notification.service';
import { UserAuthService } from '../../auth/services/user.service';
import { NotificationsTabDialogComponent } from '../../notifications/dialogs/notifications-tab-dialog/notifications-tab-dialog.component';
import { LogoutDialogComponent } from '../dialogs/logout-dialog/logout-dialog.component';
import { NewCaseDialogComponent } from '../dialogs/new-case-dialog/new-case-dialog.component';

@Component({
    selector: 'app-main-sidenav',
    templateUrl: './main-sidenav.component.html',
    styleUrls: ['./main-sidenav.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class MainSidenavComponent implements OnInit, OnDestroy {
    @Input() containsBanner: boolean;

    public readonly permissionScope = Permission;

    primaryColorSample: ElementRef;
    isMenuOpen: boolean;
    contentMargin = 280;
    screenWidth: any;
    inboxTotal: number = 0;
    activatedRouteSnapshotSubscription: Subscription;

    public unreadNotificationCount$: Observable<number>;

    callFeatureEnabled =
        this.environmentService.environmentConfig.callFeatureEnabled;

    constructor(
        public authService: UserAuthService,
        public dialog: MatDialog,
        private sideNavService: SideNavService,
        private notificationService: NotificationService,
        private router: Router,
        private navigationService: NavigationService,
        private environmentService: EnvironmentService
    ) {
        this.screenWidth = window.innerWidth;
        this.sideNavListener();
        this.navigationServiceListners();
    }

    ngOnDestroy(): void {
        this.activatedRouteSnapshotSubscription.unsubscribe();
    }

    onToolbarMenuToggle() {
        this.sideNavService.toggleMenu();
    }

    ngOnInit() {
        this.unreadNotificationCount$ =
            this.notificationService.unreadNotificationCount$;
    }

    profileReturn(err, profile, context) {
        if (profile) {
            context.userProfile = profile;
            context.userProfile.nickname =
                context.userProfile.nickname.charAt(0).toUpperCase() +
                context.userProfile.nickname.slice(1);
        }
        if (err) {
            console.error('Error getting profile', err);
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth <= 1024) {
            this.sideNavService.closeMenu();
        } else {
            this.sideNavService.openMenu();
        }
    }

    onLogout() {
        this.dialog.open(LogoutDialogComponent, {
            width: '440px',
            height: '350px',
            panelClass: 'legacy-dialog'
        });
    }

    toggleNotifications() {
        this.dialog.open(NotificationsTabDialogComponent, {
            id: 'notifications_tab_dialog',
            disableClose: true,
            autoFocus: false,
            panelClass: 'legacy-dialog',
            restoreFocus: false,
            width: '540px',
            minWidth: '540px',
            height: '100%',
            position: {
                top: '0',
                bottom: '0',
                left: '0',
                right: '50px'
            }
        });
    }

    goToProfile() {
        this.router.navigate(['/user/profile']);
    }

    private sideNavListener() {
        this.sideNavService.menuOpen$.subscribe(val => {
            this.isMenuOpen = val;
            if (!this.isMenuOpen) {
                this.contentMargin = 72;
            } else {
                this.contentMargin = 280;
            }
        });
    }

    private navigationServiceListners(): void {
        this.activatedRouteSnapshotSubscription =
            this.navigationService.activatedRouteSnapshot$
                .pipe(
                    filter(
                        params =>
                            params?.queryParamMap.has('newcase') &&
                            params?.queryParamMap.has('query')
                    )
                )
                .subscribe(() => {
                    if (!this.NewCaseDialog) {
                        this.openNewCaseDialog();
                    }
                });
    }

    get NewCaseDialog(): MatDialogRef<NewCaseDialogComponent> {
        return this.dialog.getDialogById('new_case');
    }

    public openNewCaseDialog(): void {
        if (!this.NewCaseDialog) {
            this.dialog.open(NewCaseDialogComponent, {
                id: 'new-case-dialog',
                backdropClass: 'backdrop',
                autoFocus: false,
                disableClose: true
            });
        }
    }

    public navigateToHome() {
        this.router.navigate(['/']);
    }
}
